/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { AccountInfoStatus, RequestStatus } from "~/constants";
import { getComplianceStatusAsync, getHasPaymethodAsync } from "~/features/userGuide/thunks";
import { UserGuideState } from "~/features/userGuide/types";

const initialState: UserGuideState = {
  meta: {
    complianceStatus: RequestStatus.IDLE,
    payoutInfoStatus: RequestStatus.IDLE,
    hasPaymethodStatus: RequestStatus.IDLE,
  },
  data: {
    compliance: null,
    payout: null,
    hasPaymethod: null,
  },
};

const userGuideSlice = createSlice({
  name: "userGuide",
  initialState,
  reducers: {
    setPayoutInfoStatus: (state, action: PayloadAction<AccountInfoStatus | null>) => {
      state.data.payout = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // Compliance status
      .addCase(getComplianceStatusAsync.pending, (state) => {
        state.meta.complianceStatus = RequestStatus.PENDING;
      })
      .addCase(getComplianceStatusAsync.fulfilled, (state, action) => {
        state.meta.complianceStatus = RequestStatus.SUCCESS;
        state.data.compliance = action.payload ?? null;
      })
      .addCase(getComplianceStatusAsync.rejected, (state) => {
        state.meta.complianceStatus = RequestStatus.ERROR;
      })
      // has paymethod status
      .addCase(getHasPaymethodAsync.pending, (state) => {
        state.meta.hasPaymethodStatus = RequestStatus.PENDING;
      })
      .addCase(getHasPaymethodAsync.fulfilled, (state, action) => {
        state.meta.hasPaymethodStatus = RequestStatus.SUCCESS;
        state.data.hasPaymethod = action.payload ?? false;
      })
      .addCase(getHasPaymethodAsync.rejected, (state) => {
        state.meta.hasPaymethodStatus = RequestStatus.ERROR;
      });
  },
});

export const UserGuideActions = userGuideSlice.actions;

export const userGuideReducer = userGuideSlice.reducer;
